import React from 'react'

function Color() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                fill="currentColor"
                d="M18.933 13.217l-1.012-3.615a1.875 1.875 0 00-2.31-1.297l-.57.158.397-.495a1.87 1.87 0 00-.285-2.633L12.251 2.98a1.868 1.868 0 00-2.648.27l-.75.945a.165.165 0 01-.203.06.187.187 0 01-.15-.157V2.875A1.875 1.875 0 006.625 1h-3.75A1.875 1.875 0 001 2.875v12.232A3.862 3.862 0 004.383 19h.367c.75 0 .368 0 12.87-3.473a1.883 1.883 0 001.313-2.31zm-8.182-9.015a.382.382 0 01.532-.052l2.918 2.355a.368.368 0 01.052.525l-5.438 6.75a.187.187 0 01-.202.06.195.195 0 01-.128-.18V7.082A.187.187 0 018.545 7l2.206-2.798zm-6 3.548a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-1.5-3.375a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm1.5 8.25a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm12.472 1.455l-8.108 2.25a.172.172 0 01-.202-.082.18.18 0 010-.218l4.5-5.535a.165.165 0 01.098-.06l2.49-.69a.375.375 0 01.457.263l1.043 3.615a.368.368 0 01-.278.457z"
            ></path>
        </svg>
    )
}

export default Color
